import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CouponBarcode from './components/CouponBarcode';
import CouponDetailSkeleton from './components/CouponDetailSkeleton';
import CouponInfo from './components/CouponInfo';
import CouponNote from './components/CouponNote';
import PreventCapture from './components/PreventCapture';
import useMyCoupon from './hooks/useMyCoupon';

interface Params {
    couponId: string;
}

declare module '@stackflow/config' {
    interface Register {
        CouponDetailActivity: Params;
    }
}

const TPC_MOBILE_COUPON_ID = '0rrxadr8vb9am';
const PAIKS_DABANG_COUPON_ID = '0rrtv526hg6n0';

const hideCouponIds = ['0rjmvckw80071',
    TPC_MOBILE_COUPON_ID,
    PAIKS_DABANG_COUPON_ID];

const CouponDetailActivity: ActivityComponentType<'CouponDetailActivity'> = ({ params }) => {
    const { couponId } = params;
    const { coupon, isLoading } = useMyCoupon(couponId);
    const { t } = useTranslation('coupon');
    const showBarcode = coupon?.status === 'ISSUED'
        && !hideCouponIds.includes(coupon.masterCouponId);

    return (
        <AppScreen>
            <Header title={t('detail.title')} />
            {isLoading && (<CouponDetailSkeleton/>)}
            {coupon && (
                <Fragment>
                    <CouponInfo coupon={coupon}>
                        {showBarcode && (<CouponBarcode couponNo={coupon.couponNo}/>)}
                    </CouponInfo>
                    {showBarcode && (<PreventCapture/>)}
                    <CouponNote note={coupon.note}/>
                </Fragment>
            )}
        </AppScreen>
    );
};

export default CouponDetailActivity;
